<script>

/**
 * 
 * Version 1.1
 * 
 * Permite configurable para los modos: [fetched|mixed|local]
 * 
 * @author Daniel Lepe
 * @data Marzo 23, 2024
 * 
 */
import _ from 'lodash'
import { extractForm, confirmFirst, notify } from '@/utils.js'
import uiInputHandler from "./ui-input-handler.vue";

let emptyAddingItem = {
    term: {
        value: null,
        text: null,
        item: null
    },
    cantidad: null,
    precio: null,
    sub_total: null
}

export default {
    name: 'gridInput',
    components: { uiInputHandler },
    props: {
        itemEvents: {
            type: [Array],
            default: () => { return [] }
        },
        mode: {
            type: String,
            default: 'local' // [local|fetched|mixed]
        },
        fetchingUri: {
            type: String,
            default: 'presentaciones/list'
        },
        debug: {
            type: Boolean,
            default: false
        },
        prependPrecio: {
            type: String,
            default: '$'
        },
        prependSubtotal: {
            type: String,
            default: 'Subtotal $'
        },
        labelPrice: {
            type: String,
            default: 'Precio'
        },
        takePriceFrom: {
            type: String
        },
        hidePrice: {
            type: Boolean,
            default: false
        },
        value: {
            type: [Array, Object],
            default: () => {
                return [
                    // {
                    //     parent_id: 'uno',
                    //     description: 'a',
                    //     cantidad: '1',
                    //     subtotal: '2',
                    // },
                    // {
                    //     parent_id: 'dos',
                    //     description: 'b',
                    //     cantidad: '2',
                    //     subtotal: '4',
                    // }
                ]
            }
        },
        archetype: {
            type: [Array, Function],
            default: () => {
                return [
                    // { key: 'presentacion_id', type: 'hidden' },
                    { key: 'producto', label: 'Producto', readonly: true },
                    { key: 'cantidad', label: 'Cantidad', type: 'positive', default: '0', readonly: true },
                    { key: 'precio', label: 'Precio', type: 'price', default: '0', min: "0", readonly: true },
                    { key: 'sub_total', label: 'Subtotal', type: 'price', readonly: true },
                    { key: 'comentarios' },
                ]
            }
        },
        addingController: {
            type: Function
        }
    },
    computed: {
        cArchetype() {
            // CREATE A NEW INSTANCE AND EMMIT!
            return (_.isFunction(this.archetype) ? this.archetype() : _.cloneDeep(this.archetype))
        }
    },
    methods: {
        triggerItemEvent(itemEventName, item, $index) {
            this.$emit(itemEventName, item, $index)
        },
        emitChanges() {
            // if(JSON.stringify(this.workingValue) != JSON.stringify(this.value)){
            this.$emit('input', this.workingValue);
            this.$emit('change', this.workingValue)
            // }
        },
        async askBeforeRemove($indexToRemove) {
            let text = 'Esta acción no se puede deshacer.',
                title = '¿Seguro que deseas eliminar el registro?',
                resp = (this.mode != 'local') ? (await confirmFirst({ text, title })) : true;
            if (resp) {
                const cp = _.clone(this.workingValue);
                cp.splice($indexToRemove, 1)
                this.workingValue = cp;
                this.emitChanges()
            }
        },
        productChange({ item }) {
            if (this.takePriceFrom)
                this.addingItem.precio = item[this.takePriceFrom];
        },
        calcFrom(origin, $event) {
            switch (origin) {
                case 'Precio':
                    this.addingItem.sub_total = ($event * this.addingItem.cantidad).toFixed(2)
                    break
                case 'Subtotal':
                    this.addingItem.precio = ($event / this.addingItem.cantidad).toFixed(2)
                    break
                case 'Unidades':
                    this.addingItem.sub_total = (this.addingItem.precio * this.addingItem.cantidad).toFixed(2)
                    break
                default:
                    if (!this.takePriceFrom)
                        this.addingItem.sub_total = (this.addingItem.precio * this.addingItem.cantidad).toFixed(2)
                    break
            }
            console.log('calcFrom', origin, $event)
        },
        addOneEmpty() {
            try {
                let data2add = extractForm(this.cArchetype);
                // LLAMA A LA FUNCIÓN CONFIGURADORA.
                if (_.isFunction(this.addingController))
                    data2add = this.addingController(data2add)
                
                // FINALLY ADDS THE ITEM
                this.workingValue.push(data2add)
                // LIMPIA LA CONFIGURACIÓN ACTUAL
                this.cleanInputs()
                this.emitChanges()

            } catch (e) {
                notify(e)
            }
        },
        addOne() {
            try {
                // QUICK ADDING VALIDATIONS
                this.quickAddingValidations()

                // EXTRAE UN NUEVO OBJETO SEGÚN EL ARQUETIPO ESPECIFICADO.
                let data2add = _.merge(extractForm(this.cArchetype), this.addingItem),
                    addingItem = _.cloneDeep(this.addingItem);

                // AGREGA ITEM, QUE SE USARÁ APOSTERIORI PARA POSIBLES RECÁLCULOS Y SUMARIOS
                data2add.item = _.clone(addingItem.item)

                // AJUSTES DE OBJETO
                data2add.presentacion_id = addingItem.term.value;
                data2add.producto = addingItem.term.text;
                // data2add.cantidad 			= addingItem.cantidad;
                // data2add.sub_total 			= addingItem.sub_total;
                // data2add.precio 		    = addingItem.precio;

                // LLAMA A LA FUNCIÓN CONFIGURADORA.
                if (_.isFunction(this.addingController))
                    data2add = this.addingController(data2add, addingItem)

                // INSERTA EN EL ARREGLO
                this.workingValue.push(_.clone(data2add))

                console.debug(data2add)

                // LIMPIA LA CONFIGURACIÓN ACTUAL
                this.cleanInputs()

                this.emitChanges()

            } catch (e) {
                notify(e)
            }
        },
        quickAddingValidations() {
            if (!this.addingItem.term.value)
                throw 'Debes seleccionar un producto antes de continuar';
            if (_.isNaN(this.addingItem.sub_total) || this.addingItem.sub_total < 0)
                throw 'El sub_total debe ser positivo de compra debe ser un número';
            if (!this.addingItem.cantidad || this.addingItem.cantidad < 0)
                throw 'Debes definir una cantidad positiva';
        },
        cleanInputs() {
            this.addingItem = _.clone(emptyAddingItem)
            this.$refs.mobiscrollInputSearch.clean()
        }
    },
    data: () => {
        return {
            addingItem: _.clone(emptyAddingItem),
            workingValue: []
        }
    },
    beforeMount() {
        if (_.isArray(this.value) && this.value.length) {
            this.workingValue = _.cloneDeep(this.value)
        }
    },
    mounted() {
        this.emitChanges()
    }
}

</script>

<template>
    <b-card class="grid-input">

        <div slot="header">
            <!-- <b-form size="small" inline> -->
            <b-row align-h="end">

                <template v-if="['fetched', 'mixed'].indexOf(mode) != -1">

                    <b-col>
                        <mobiscroll-input-search key-value="id" ref="mobiscrollInputSearch" class="productSearch"
                            v-model="addingItem.term" @change="productChange" :uri="fetchingUri"
                            keyText="titulo_extendido" />
                        <pre v-if="debug">{{ addingItem.term }}</pre>
                    </b-col>

                    <template v-if="addingItem.term.item">

                        <b-col>
                            <b-input-group prepend="Cant.">
                                <b-input v-model="addingItem.cantidad" type="number" @keyup.enter="addOne('Unidades')"
                                    @change="calcFrom('Unidades', $event)" min=0></b-input>
                            </b-input-group>
                        </b-col>

                        <!-- CÁLCULOO DESDE PRECIO DINÁMICO -->
                        <template v-if="takePriceFrom">

                            <b-col key="precio">
                                <b-input-group :prepend="prependPrecio">
                                    <b-input :value="addingItem.term.item[takePriceFrom]" type="number" readonly />
                                </b-input-group>
                            </b-col>

                            <b-col key="sub_total">
                                <b-input-group :prepend="prependSubtotal" class="subtotalInput">
                                    <b-input :value="addingItem.term.item[takePriceFrom] * (addingItem.cantidad)"
                                        type="number" readonly />
                                </b-input-group>
                            </b-col>

                        </template>


                        <!-- CALCULO CON CAPTURA DE PRECIO -->
                        <template v-else>
                            <b-col>
                                <b-input-group :prepend="prependPrecio">
                                    <b-input v-model="addingItem.precio" type="number" steps="2"
                                        @keyup.enter="addOne('Precio')" @change="calcFrom('Precio', $event)" min="0" />
                                </b-input-group>
                            </b-col>
                            <b-col>
                                <b-input-group :prepend="prependSubtotal" class="subtotalInput">
                                    <b-input v-model="addingItem.sub_total" type="number" steps="2"
                                        @keyup.enter="addOne('Subtotal')" @change="calcFrom('Subtotal', $event)"
                                        min="0" />
                                </b-input-group>
                            </b-col>
                        </template>

                        <b-col>
                            <b-button @click="addOne">
                                <i class="fa fa-plus"></i>
                            </b-button>
                        </b-col>

                    </template>

                </template>

                <b-col md="2" v-if="['local', 'mixed'].indexOf(mode) != -1">
                    <b-button variant="primary" block @click="addOneEmpty">
                        <div class="fa fa-plus"></div>
                    </b-button>
                </b-col>
            </b-row>
            <!-- </b-form> -->
        </div>
        <div class="content">
            <b-jumbotron header="Lista vacía" lead="Intenta agregando un producto con las herramientas de arriba"
                v-if="!workingValue.length">

            </b-jumbotron>
            <div class="sim-row" v-for="(wValue, $index) in workingValue" :key="'wValue' + $index">
                <ui-input-handler v-model="workingValue[$index][item.key]" v-for="item in cArchetype" :key="item.key"
                    class="sim-item" :class="item.key" :f-arch="item" />
                <div class="sim-row remove">
                    <b-button-group>
                        <b-button v-for="btn in itemEvents" :key="btn"
                            @click="triggerItemEvent(btn, workingValue[$index], { index: $index })">{{ btn }}</b-button>
                        <b-button variant="danger" @click="askBeforeRemove($index)"><i
                                class="fa fa-trash"></i></b-button>
                    </b-button-group>
                </div>
            </div>
        </div>
        <pre v-if="debug">{{ cArchetype }}</pre>
        <pre v-if="debug">{{ workingValue }}</pre>
    </b-card>
</template>

<style lang="less">
.grid-input {
    .productSearch {
        width: 20em;
    }

    .subtotalInput {
        width: 16em;
    }

    .content {
        width: 100%;
        display: flex;
        flex-flow: column-reverse;
        gap: 0.75em;
        overflow-x: auto;

        .sim-row {
            display: block;
            display: flex;
            flex-flow: row;
            gap: 0.5em;

            &:not(:last-child) {
                label {
                    display: none !important;
                    // opacity: 0;
                }
            }

            .form-group {
                margin-bottom: 0;
            }

            .remove {
                display: flex-block;
                flex-flow: column;
                justify-content: end;
            }

            .sim-item {
                flex: 1 0 5em;

                &.producto {
                    flex: 1 0 auto;

                    INPUT {
                        width: 30em;
                    }
                }

                &.comentarios {
                    flex: 0 0 7em;
                }
            }
        }
    }
}
</style>